import "Feature/SimpleLanguage/code/Styles/simpleLanguageSignInMetaNavigation.scss"

window.am = window.am || {};

window.am.simpleLanguageSignInMetaNavigation = new function () {
    const elementClassHide = 'simple-language-mobile-sign-in--hide';
    let collapse;
    let navElement;
    
    const init = () => {
        window.addEventListener("mobileNavigationNavItem", simpleLanguageMobileSignIn);
    };

    const simpleLanguageMobileSignIn = (e) => {
        const event = e.detail.event;
        navElement = e.detail.params.element;
        const parent = navElement.parent();

        if (event != "simpleLanguageMobileSignIn") {
            return;
        }

        navElement.classList.add(elementClassHide);
                
        collapse = document.querySelector('.simple-language-mobile-sign-in__collapse');
        collapse.classList.remove(elementClassHide);
        
        const closeSignIn = parent.querySelector('.simple-language-mobile__close-sign-in');
        closeSignIn.addEventListener('click', onCloseSignInClick);
        collapse.scrollIntoView();
    };

    const onCloseSignInClick = () => {
        if (collapse) {
            collapse.classList.add(elementClassHide);
        }
        
        if (navElement) {
            navElement.classList.remove(elementClassHide);
        }
    };

    return {
        init: init
    };
};

window.addEventListener('load', window.am.simpleLanguageSignInMetaNavigation.init);